// TOP 3 polecających — popup końca akcji. Renderowany serwerowo tylko gdy user
// go jeszcze nie zamknął (flaga w bazie). Zamknięcie zapisuje flagę przez POST,
// więc popup nie wraca — także na innym urządzeniu (wzór: winning-team.js).
(function () {
    const modal = document.querySelector('#js-referral-top3');
    if (!modal) return;

    let dismissed = false;
    const dismiss = () => {
        if (dismissed) return;
        dismissed = true;
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        fetch('/referral-top3/seen', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        }).catch(() => { /* best-effort */ });
    };

    document.querySelector('#js-referral-top3-close')?.addEventListener('click', dismiss);
    modal.querySelector('[data-referral-top3-close]')?.addEventListener('click', dismiss);
})();
